import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { InventoriesStoreModule } from './store'

@NgModule({
  imports: [CommonModule, InventoriesStoreModule],
  exports: [InventoriesStoreModule],
})
export class InventoriesLibraryModule {}
